import React from 'react';
import styled, { css } from 'styled-components';
import { black, red } from '@avangard/ui/colors';

import { Link } from '@lib/routing';
import { DashboardCard } from '@modules/dashboard/moleculas';

export type DashboardWidgetProps = {
    label: string;
    children: React.ReactNode;
    href?: string;
    linkState?: Record<string, unknown>;
    loading?: boolean;
    className?: string;
};

const Root = styled(DashboardCard)<{ withoutPadding?: boolean }>`
    ${p =>
        p.withoutPadding &&
        css`
            padding: 0;
        `}
`;

const Label = styled.div`
    width: 100%;
    margin-bottom: auto;
    color: ${black[40]};
    font-size: 1.4rem;
    font-weight: 400;
`;

const Body = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-top: 8px;
    color: ${black[80]};
    transition: color 0.2s;
`;

const StyledLink = styled(Link)`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 16px;

    &:hover ${Body} {
        color: ${red[100]};
    }
`;

const DashboardWidget = (props: DashboardWidgetProps): React.ReactElement => {
    const { loading, href, linkState, label, children, className } = props;

    const renderBody = () => (
        <>
            <Label>{label}</Label>
            <Body>{children}</Body>
        </>
    );

    return (
        <Root withoutPadding={!!href} loading={loading} className={className}>
            {href ? (
                <StyledLink to={href} state={linkState}>
                    {renderBody()}
                </StyledLink>
            ) : (
                renderBody()
            )}
        </Root>
    );
};

export { DashboardWidget };
